import { put, takeLatest, fork, call } from "redux-saga/effects";
import {
  IUpdateUserStatusPayload,
  ActionType,
  UpdateUserStatusResponse,
} from "models/userListBusiness/updateUserStatus";
import { httpStatus } from "configs/httpStatus";
import { updateUserStatus } from "services/userListBusiness";
import {
  handleSuccesAction,
  handleErrorAction,
} from "./updateUserStatusActions";

function* updateUserStatusSaga({
  payload,
}: {
  payload: IUpdateUserStatusPayload;
}) {
  try {
    const response: UpdateUserStatusResponse = yield call(
      updateUserStatus,
      payload
    );
    if (
      response.status === httpStatus.StatusOK ||
      response.status === httpStatus.StatusCreated ||
      response.status === httpStatus.StatusUnprocessableEntity
    ) {
      yield put(handleSuccesAction(response));
    } else {
      yield put(handleErrorAction(response.message || ""));
    }
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onUpdateUserStatusWatcher() {
  yield takeLatest(ActionType.UPDATE_USER_STATUS as any, updateUserStatusSaga);
}

export default [fork(onUpdateUserStatusWatcher)];
